import { render, staticRenderFns } from "./CTeacherRecommend.vue?vue&type=template&id=1616dfa4&scoped=true&"
import script from "./CTeacherRecommend.vue?vue&type=script&lang=js&"
export * from "./CTeacherRecommend.vue?vue&type=script&lang=js&"
import style0 from "./CTeacherRecommend.vue?vue&type=style&index=0&id=1616dfa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1616dfa4",
  null
  
)

export default component.exports